import React, { ChangeEvent, ReactElement, SyntheticEvent, useState } from 'react';

import './join-us-form.scss';
import Button from 'atomic/button/button';
import Link from 'atomic/link/link';
import { useFetch } from 'hooks/use-fetch';
import classNames from 'classnames';
import JoinUsFormLayout from 'components/join-us/form-layout/join-us-form-layout';

interface JoinUsFormProps {
    onNextStep: () => void;
    onPrevStep: () => void;
}

const JoinUsForm: React.FC<JoinUsFormProps> = ({ onNextStep, onPrevStep }): ReactElement => {
    const [name, setName] = useState('');
    const [error, setError] = useState('');
    const postFetch = useFetch('/company/join-us');

    const handleSubmit = (e: SyntheticEvent): void => {
        e.preventDefault();

        if (name) {
            postFetch.post({ name })
                .then((data: { statusCode: number; message?: string; }) => {
                    if (data.statusCode === 200) {
                        onNextStep();
                    } else {
                        setError(data.message || 'Niepoprawny adres url.');
                    }
                });
        }
    };

    const handleChangeName = (e: ChangeEvent<HTMLInputElement>): void => {
        setName(e.target.value);
        setError('');
    };

    return (
        <JoinUsFormLayout footerButtonLabel="Cofnij" footerButtonOnClick={onPrevStep}>
            <form className="join-us-form__form" action="#" id="joinUsForm"
                method="POST" onSubmit={handleSubmit}
            >
                <div className="form-group">
                    <label className="join-us-form__label" htmlFor="companyNameOrUrl">
                        Strona www sklepu lub firmy
                    </label>
                    <input
                        className={classNames({
                            'join-us-form__input': true,
                            'join-us-form__input--error': Boolean(error)
                        })}
                        id="companyNameOrUrl"
                        name="companyNameOrUrl"
                        value={name}
                        required={true}
                        onChange={handleChangeName}
                    />
                    {error && (
                        <div className="join-us-form__error">
                            {error}
                        </div>
                    )}
                </div>
                <p className="join-us-form__info">
                    Wysłanie zgłoszenia jest równoznaczne z akceptacją
                    {' '}
                    <Link
                        className="join-us-form__link"
                        href="https://www.opineo.pl/i/dla-uzytkownika/regulamin-dla-uzytkownikow-serwisu"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Regulaminu Opineo.pl
                    </Link>
                </p>
                <input type="hidden" name="userType" value="client"/>
                <Button type="submit" className="join-us-form__button" uppercase={true}
                    disabled={postFetch.loading}
                >
                    Zaproponuj sklep lub firmę
                </Button>
            </form>
        </JoinUsFormLayout>
    );
};

export default JoinUsForm;
